import { Email, LocalPhone, LocationOn } from "@mui/icons-material";
import { Grid } from "@mui/material";
import "./CustomCard.scss";

const CustomCard = ({ title, phoneList, imgId, location, emailList }) => {
  const imgSrc = require(`../../assets/home/${imgId}`);

  return (
    <div className="CustomCard">
      <div className="green-island-card">
        <div className="green-island-card__header">
          <img
            src={imgSrc}
            alt="contact card"
            style={{ borderRadius: "10px" }}
          />
        </div>
        <div className="green-island-card__title">{title}</div>
        <div className="green-island-card__message">
          <Grid container spacing={2} justifyContent={"center"}>
            {phoneList ? (
              phoneList.map((phone, index) => (
                <Grid item xs={12} sm={6}>
                  <p key={index}>
                    <LocalPhone />
                    {phone}
                  </p>
                </Grid>
              ))
            ) : (
              <></>
            )}
          </Grid>
        </div>
        <div className="green-island-card__message">
          <Grid container spacing={2} justifyContent={"center"}>
            {emailList ? (
              emailList.map((mail, index) => (
                <Grid item xs={12} xl={6}>
                  <p key={index}>
                    <Email
                      style={{ paddingRight: "6px", verticalAlign: "top" }}
                    />
                    {mail}
                  </p>
                </Grid>
              ))
            ) : (
              <></>
            )}
          </Grid>
        </div>
        <div
          className="green-island-card__message"
          style={{ border: "0px", paddingBottom: "0px" }}>
          <p>
            <LocationOn style={{ paddingRight: "6px", verticalAlign: "top" }} />
            {location}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CustomCard;
